import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { ExitFromParkingFormSchemaValues } from 'src/features/stay/utils/formSchema';

const RESOURCE = `sp-core/:parkingId/visitors/active-stay/:stayId/end/`;

interface DTO extends ExitFromParkingFormSchemaValues {
    stayId: string;
    parkingId: string;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ stayId, parkingId, ...data }: DTO): Promise<{ past_stay_id: string | null }> => {
    return axios.post(formatResourcePath(RESOURCE, { stayId, parkingId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useEndActiveStay };
